import { c as _c } from "react/compiler-runtime";
import { EmptyState } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { NavigationHeader } from '../layout';
type GenericErrorPageProps = {
  onRetry: () => void;
  retryLimitExceeded?: boolean;
};
const GenericErrorPage = t0 => {
  const $ = _c(14);
  const {
    onRetry,
    retryLimitExceeded
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "global.components.generic-error"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavigationHeader leftButton={{
      variant: "close",
      confirmClose: true
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp2);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onRetry || $[7] !== retryLimitExceeded || $[8] !== t) {
    t5 = retryLimitExceeded ? undefined : {
      label: t(_temp3),
      onClick: onRetry
    };
    $[6] = onRetry;
    $[7] = retryLimitExceeded;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <>{t2}<EmptyState description={t3} title={t4} cta={t5} /></>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default GenericErrorPage;
function _temp($) {
  return $.description;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.cta;
}